import { Button, Collapse, Typography } from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { useState } from "react";
import SingleUserAnalyticsViewer from "./SingleUserAnalyticsViewer";

const SingleDateUserAnalyticsViewer = ({ date, dateData }) => {
  const [isOpen, setIsOpen] = useState(false);
  let allTypes = Object.keys(dateData);

  const onToggle = () => {
    setIsOpen((p) => !p);
  };

  return (
    <>
      <Button
        onClick={onToggle}
        disableRipple
        sx={{
          justifyContent: "space-between",
          display: "flex",
          alignItems: "center",
          flexDirection: "row",
          textTransform: "none",
        }}
      >
        <Typography variant="h6" color="primary.main" sx={{ fontSize: "15px" }}>
          {date}
        </Typography>

        {isOpen ? (
          <KeyboardArrowUp sx={{ marginLeft: "20px" }} />
        ) : (
          <KeyboardArrowDown sx={{ marginLeft: "20px" }} />
        )}
      </Button>
      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        <div style={{ marginLeft: "10px" }}>
          {allTypes.map((type) => {
            return dateData[type].map((user) => {
              return (
                <SingleUserAnalyticsViewer
                  key={user.email + type}
                  user={user}
                  type={type}
                />
              );
            });
          })}
        </div>
      </Collapse>
    </>
  );
};

export default SingleDateUserAnalyticsViewer;
